import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Spin, Button, Table } from 'antd';

import moment from 'moment';
import RefillsList from './RefillsList';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

class OpalPatientStatus extends Component {
    state = {
        loading: false,
    }

    componentDidMount = () => {
        const { setRefills } = this.props;

        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/carefills/opal_patient_status.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                setRefills(response.data.carefills);
                this.setState({
                    loading: false,
                });
            });
    }

    printOpalList = () => {
        const printContent = document.getElementById('print-content').innerHTML;
        document.body.innerHTML = printContent;
        window.print();
        window.location.reload();
    }


    render() {
        const { loading } = this.state;
        const { refillsList } = this.props;

        const column = [
            {
                title: 'Name',
                key: 'patient_name',
                dataIndex: 'patient_name',
                align: 'center',
            }, {
                title: 'End Date',
                key: 'end_date',
                dataIndex: 'end_date',
                align: 'center',
            }, {
                title: 'Start Date',
                key: 'start_date',
                align: 'center',
                render: record => (
                    moment(record.start_date).add(1, 'days').format('YYYY-MM-DD')
                ),
            }, {
                title: 'Status',
                key: 'status',
                align: 'center',
                dataIndex: 'order_status',
            },
        ];

        return (
            <div>
                {
                    loading
                        ? <Spin />
                        : <RefillsList />
                }
                <Button disabled={loading} color="primary" style={{ marginTop: 40 }} onClick={this.printOpalList}>Print Report</Button>

                <div id="print-content" style={{ display: 'none' }}>
                    <h5 style={{ textAlign: 'center' }}>Opal Patient List</h5>

                    <hr />

                    <Table
                        pagination={false}
                        dataSource={refillsList}
                        className="printHead"
                        rowClassName="printColumn"
                        columns={column}
                        bordered
                        size="small"
                        style={{ whiteSpace: 'pre', outline: '1px solid black', fontSize: '7px' }}
                    />

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpalPatientStatus);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/OpalPatientStatus.js